function linkResolver(doc) {
  if (doc) {
    switch (doc.type) {
      case "home":
        return "/";
      case "privacy_policy":
        return "/privacy-policy";
      case "mayors_blog":
        return "/mayors-blog";
      case "questions":
        return "/questions-answered";
      default:
        if (doc.uid) {
          return `/${doc.uid}`;
        }

        return `/${doc.type}`;
    }
  }

  return "/";
}

export default linkResolver;
